// src/components/ProtectedRoute.js
import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);  // code to check whther user is logged in or not very important for live mode
  // const [user,loading] = useState(true);
  console.log("user:", user, "loading:", loading);


  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute;